import React, { useState } from 'react';
import { AlertCircle, Check, X } from 'react-feather';
import './ConfirmToast.css';

export interface ConfirmOptions {
    id: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string;
    cancelText?: string;
}

interface ConfirmToastProps {
    options: ConfirmOptions;
    onClose: (id: string) => void;
}

export const ConfirmToast: React.FC<ConfirmToastProps> = ({ options, onClose }) => {
    const [isExiting, setIsExiting] = useState(false);

    const handleConfirm = () => {
        setIsExiting(true);
        setTimeout(() => {
            options.onConfirm();
            onClose(options.id);
        }, 300);
    };

    const handleCancel = () => {
        setIsExiting(true);
        setTimeout(() => {
            options.onCancel();
            onClose(options.id);
        }, 300);
    };

    return (
        <div className={`confirm-toast ${isExiting ? 'confirm-toast-exit' : ''}`}>
            <div className="confirm-toast-icon">
                <AlertCircle size={20} />
            </div>
            <div className="confirm-toast-message">
                {options.message}
            </div>
            <div className="confirm-toast-actions">
                <button
                    className="confirm-toast-btn confirm-toast-btn-cancel"
                    onClick={handleCancel}
                >
                    <X size={16} />
                    {options.cancelText || 'Cancelar'}
                </button>
                <button
                    className="confirm-toast-btn confirm-toast-btn-confirm"
                    onClick={handleConfirm}
                >
                    <Check size={16} />
                    {options.confirmText || 'Confirmar'}
                </button>
            </div>
        </div>
    );
};
